/**
 * The names of the FeatureFlags stored in RemoteConfig.
 */
export const CHALLENGE_TOGGLE = 'challengeToggle'
export const PROGRAMS = 'programs'
export const DESIGN_2_0 = 'design_2_0'
